import { useEffect, useState } from 'react';
export const useRequest = (requestFn) => {
    const [state, setState] = useState({
        loading: true,
        response: null,
        error: null,
    });
    useEffect(() => {
        const execRequest = async () => {
            try {
                const response = await requestFn();
                setState({ loading: false, response, error: null });
            }
            catch (error) {
                setState({ loading: false, response: null, error });
            }
        };
        execRequest();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return state;
};
//# sourceMappingURL=useRequest.js.map